import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { InspectionValueCase } from '@authority-labs/api-interfaces';
import { TranslocoService } from '@ngneat/transloco';
import { NotesBankDialogService } from '@check-list/app/shared/dialogs/notes-bank-dialog/notes-bank-dialog.service';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-value-case',
  templateUrl: './check-value-case.component.html',
  styleUrls: ['./check-value-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckValueCaseComponent
  extends CheckBasicCaseComponent
  implements OnInit
{
  @Input() inspection: InspectionValueCase;
  @Input() label: string;
  @Input() notesBankType: string;

  constructor(
    private notesBankDialogService: NotesBankDialogService,
    private translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.label) {
      this.label = this.translocoService.translate('inspection.fields.value');
    }
  }

  showNotesBank(e: Event) {
    e.stopPropagation();
    this.notesBankDialogService
      .show(this.notesBankType)
      .afterClosed()
      .subscribe((selected) => {
        if (selected) {
          this.inspection.value = selected;
          super.onChange();
        }
      });
  }
}
